import LangEnum from '../../../lang/LangEnum';
import { MediaFormatEnum } from '../enums/mediaFormat.enum';

export const getMediaFormatLangEnum = (value: MediaFormatEnum) => {
  const mappedLabel: {
    [key in MediaFormatEnum]: LangEnum;
  } = {
    SQUARE: LangEnum.GLOBAL_MEDIA_SQUARE,
    RECTANGULAR: LangEnum.GLOBAL_MEDIA_RECTANGULAR,
  };
  return mappedLabel[value];
};
